// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__Tllro","loaderOuter":"PageOverlayLoader_loaderOuter__22u12"};